import type { IDBPTransaction, StoreNames } from 'idb';

import { docKeyScope } from '../../local-data/payload';
import { localCipherReferenceStores } from './encryption';
import type { DocStorageSchema } from './schema';

export const publicationDocDeleteStores = [
  'updates',
  'snapshots',
  'clocks',
  'publications',
  'publicationActors',
  'docKeyRegistry',
  ...localCipherReferenceStores,
] as const satisfies readonly StoreNames<DocStorageSchema>[];

/**
 * Removes the local bytes, clocks and publication actors of docIds and drops
 * every sealed key no payload references any more. The caller deletes the
 * journal entries of these documents first, in the same transaction.
 */
export async function deleteLocalPublicationDocs(
  tx: IDBPTransaction<
    DocStorageSchema,
    StoreNames<DocStorageSchema>[],
    'readwrite'
  >,
  docIds: readonly string[]
): Promise<void> {
  for (const docId of docIds) {
    const updates = tx.objectStore('updates');
    for (const key of await updates.index('docId').getAllKeys(docId))
      await updates.delete(key);
    await tx.objectStore('snapshots').delete(docId);
    await tx.objectStore('clocks').delete(docId);
    await tx.objectStore('publicationActors').delete(docId);
    const registry = tx.objectStore('docKeyRegistry');
    const key = await registry.index('keyScopeId').getKey(docKeyScope(docId));
    if (key) {
      let referenced = false;
      for (const store of localCipherReferenceStores) {
        if (
          await tx
            .objectStore(store)
            .index('keyScopeId')
            .count(docKeyScope(docId))
        ) {
          referenced = true;
          break;
        }
      }
      if (!referenced) await registry.delete(key);
    }
  }
}
